import utils from '@/mixins/utils'
import { formatarCadastrosComDoses } from './functions.js'

const CAMPOS_CORES = [
  'coresCovid19',
  'coresPenta',
  'coresVip',
  'coresDtp',
  'coresBcg',
  'coresHepatiteB',
  'coresPneumococica',
  'coresRotaVirus',
  'coresMeningococicaC',
  'coresFebreAmarela',
  'coresHepatiteA',
  'coresTripliceViral',
  'coresTetraViral',
  'coresVaricela',
  'coresHpv',
  'coresAcwy',
  'coresDuplaAdulto',
]

/**
 * Filtra os dados
 *
 * @param {Array} cadastros
 * @param {Boolean} exibirVermelhos
 * @param {Boolean} exibirVerdes
 * @param {Object} selectedFilterIdade
 * @param {Object} selectedFilterVacinas
 * @returns {Array}
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  selectedFilterIdade,
  selectedFilterVacinas
) {
  let cadastrosFiltrados = formatarCadastrosComDoses(cadastros).map((item) => ({
    ...item,
    rowClass: getClasseCorRegistro(item),
  }))

  if (selectedFilterIdade != null) {
    cadastrosFiltrados = filtrarPorIdade(
      cadastrosFiltrados,
      selectedFilterIdade
    )
  }

  if (selectedFilterVacinas != null) {
    return filtrarPorVacina(
      cadastrosFiltrados,
      exibirVermelhos,
      exibirVerdes,
      selectedFilterVacinas
    )
  }

  if (exibirVermelhos === true) {
    cadastrosFiltrados = buscarVermelhos(cadastrosFiltrados)
  }

  if (exibirVerdes === true) {
    cadastrosFiltrados = buscarVerdes(cadastrosFiltrados)
  }

  return cadastrosFiltrados
}

/**
 * Retorna a classe da linha da tabela para pintar de vermelho ou verde
 *
 * @param {object} item
 * @returns {String}
 */
function getClasseCorRegistro(item) {
  const temRed = CAMPOS_CORES.some((campo) => {
    const arr = item[campo]
    return Array.isArray(arr) && arr.some((dose) => dose.cor === 'red')
  })

  if (temRed) {
    return 'table-row-color-red'
  }

  const todasPermitidas = CAMPOS_CORES.every((campo) => {
    const arr = item[campo]
    return (
      Array.isArray(arr) &&
      arr.every((dose) => dose.cor === 'green' || dose.cor === 'white')
    )
  })

  if (todasPermitidas) {
    return 'table-row-color-green'
  }

  return ''
}

/**
 * Filtra os registros classificados como vermelhos.
 * @param {Array} cadastros Lista de registros
 * @returns {Array}
 */
function buscarVermelhos(cadastros) {
  return cadastros.filter((item) => item.rowClass === 'table-row-color-red')
}

/**
 * Filtra os registros classificados como verdes.
 * @param {Array} cadastros Lista de registros
 * @returns {Array}
 */
function buscarVerdes(cadastros) {
  return cadastros.filter((item) => item.rowClass === 'table-row-color-green')
}

/**
 * Filtro por idade
 *
 * @param {Array} cadastros
 * @param {Object} filter
 * @returns {array}
 */
function filtrarPorIdade(cadastros, filter) {
  let filtrado = cadastros.filter((item) => {
    if (filter === null) {
      return item
    }
    if (filter.value === '0 - 24 meses') {
      return Number(item.idade_meses) >= 0 && Number(item.idade_meses) <= 24
    } else if (filter.value === '2 - 4 anos') {
      return Number(item.idade_anos) >= 2 && Number(item.idade_anos) <= 4
    } else if (filter.value === '5 - 10 anos') {
      return Number(item.idade_anos) >= 5 && Number(item.idade_anos) <= 10
    } else if (filter.value === '11 - 14 anos') {
      return Number(item.idade_anos) >= 11 && Number(item.idade_anos) <= 14
    } else {
      return item
    }
  })
  return filtrado
}

/**
 * Filtro por vacina
 *
 * @param {array} cadastros
 * @param {boolean} exibirVermelhos
 * @param {boolean} exibirVerdes
 * @param {object} filter
 * @returns {array}
 */
function filtrarPorVacina(cadastros, exibirVermelhos, exibirVerdes, filter) {
  let vacina = filter.value

  if (vacina == null) return cadastros

  if (exibirVermelhos === true) {
    return cadastros
      .filter((el) => {
        return el[vacina].some((dose) => dose.cor === 'red')
      })
      .map((el) => ({
        ...el,
        rowClass: 'table-row-color-red',
      }))
  }

  if (exibirVerdes === true) {
    return cadastros
      .filter(
        (el) =>
          el[vacina].some((d) => d.cor === 'green') &&
          el[vacina].every((d) => d.cor !== 'red')
      )
      .map((el) => ({
        ...el,
        rowClass: 'table-row-color-green',
      }))
  }
}
